import { graphql } from '@/gql'
import { useForm } from '@/helpers/useForm'
import { type BaseProps, Dialog, DialogBody, DialogTitle } from '@/components/base/dialog'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'

const CreateItemTypeMutation = graphql(`
  mutation CreateItemType($name: String!) {
    createItemType(input: { name: $name }) {
      itemType { id name }
      errors { path message }
    }
  }
`)

export const Create = ({ open, setOpen }: BaseProps) => {
  const navigate = useNavigate()

  const {
    save,
    saveSuccess,
    formBuilder,
    mutationData,
    mutationLoading,
  } = useForm({
    mutation: CreateItemTypeMutation,
    resultKey: 'createItemType',
  })

  useEffect(() => { if (saveSuccess) navigate(`/item_types/${mutationData?.createItemType.itemType?.id}`) }, [saveSuccess, mutationData, navigate])

  return (
    <Dialog open={ open } size="5xl" onClose={ setOpen }>
      <DialogTitle>New item type</DialogTitle>
      <DialogBody>
        <div className="flex flex-col gap-6">
          { formBuilder.buildQueryError() }
          { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
          { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
        </div>
      </DialogBody>
    </Dialog>
  )
}
